import { getEnv } from '@unni/platform'

export const isProd = getEnv('NEXT_PUBLIC_ENV') === 'prod'
export const isTest = getEnv('NEXT_PUBLIC_ENV') === 'test'
export const isDev = getEnv('NEXT_PUBLIC_ENV') === 'local'
